<template>
  <v-container>
    <v-card :elevation="10">
      <v-card-title>
        <h3>報告書の保存</h3>
      </v-card-title>
      <v-card-text
        class="text-center pa-10">
        <v-alert
          v-if="!saved"
          dark
          outlined
          color="info">
          この内容を保存します。よろしいですか？
        </v-alert>
        <v-alert
          v-else
          dark
          outlined
          color="success">
          <v-icon
            color="success">
            mdi-check
          </v-icon>
          報告書を保存しました。
        </v-alert>
        <v-row dense>
          <v-col class="text-right title">委託業務名</v-col>
          <v-col class="text-left title">{{ step2Form.title }}</v-col>
        </v-row>
        <v-row dense>
          <v-col class="text-right title">施設名</v-col>
          <v-col class="text-left title">{{ step2Form.facility_name }}</v-col>
        </v-row>
        <v-row
          justify="center"
          class="mt-10"
          dense>
          <v-checkbox
            v-if="!isApprovalUser"
            v-model="isCheckedSendMail"
            color="success">
            <template #label>
              <div class="success--text font-weight-bold">承認申請を出す(メールで通知する)</div>
            </template>
          </v-checkbox>
        </v-row>
        <v-row v-if="!saved && isApprovalUser">
          <v-col>
            <v-btn
              v-if="!saved"
              dark
              x-large
              class="mb-10 mr-5"
              color="primary"
              :disabled="loading"
              @click.prevent="onSaveButtonClicked()">
              保存する
            </v-btn>
            <v-btn
              dark
              x-large
              class="mb-10"
              color="success"
              :disabled="loading"
              @click.prevent="onApproveButtonClicked(true)">
              承認する
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-btn
              v-if="!saved"
              dark
              x-large
              class="mb-10 ml-5"
              color="primary"
              :disabled="loading"
              @click.prevent="onSaveButtonClicked()">
              保存する
            </v-btn>
            <v-btn
              v-else
              dark
              x-large
              class="mb-10"
              color="primary"
              @click.prevent="onNextClicked">
              <v-icon>mdi-exit-run</v-icon>
              トップに戻る
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <global-footer>
      <template #left>
        <v-btn
          large
          @click.prevent="onReturnClicked">
          <v-icon>mdi-chevron-left</v-icon>
          戻る
        </v-btn>
      </template>
      <template #right>
        <v-btn
          large
          color="warning"
          @click.prevent="onNextClicked">
          修了
          <v-icon right>mdi-exit-run</v-icon>
        </v-btn>
      </template>
    </global-footer>
  </v-container>
</template>

<script>

import { getStepSession, markAsSavedSession, setStepSession } from '../../logic/session'

export default {
  name: 'ReportFormStep3',
  components: { },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      saved: false,
      step2Form: {},
      project: {},
      isCheckedSendMail: false,
    }
  },
  computed: {
    isApprovalUser() {
      if (this.$store.state.auth.permission === 2) {
        return true
      }
      return this.project.users
        ? this.project.users.filter(
          user => (
            user.id === this.$store.state.auth.id
            && user.pivot.role_id === 2
            && user.has_approval_authority
          ),
        ).length > 0
        : false
    },
  },
  mounted() {
    this.loadItem()
  },
  methods: {
    loadItem() {
      const form2 = getStepSession('report', 2)
      if (form2) {
        this.step2Form = form2
      }
      this.saved = !!getStepSession('report', 3)
      this.fetchItem()
    },
    async fetchItem() {
      const { data } = await window.axios.get(`/api/reports/${this.id}`)
      this.project = data
    },
    async saveItem() {
      this.loading = true
      await window.axios.put(`/api/reports/${this.id}`, { ...this.step2Form, isCheckedSendMail: this.isCheckedSendMail })
      this.loading = false
    },
    async onSaveButtonClicked() {
      await this.saveItem()

      markAsSavedSession('report')
      setStepSession('report', 3, `${this.id}`)
      this.saved = true
      this.$emit('hasChange', false)
    },
    async onApproveButtonClicked(approved) {
      this.loading = true
      await window.axios.put(`/api/reports/${this.id}`, { ...this.step2Form, reportApproved: true })
      await window.axios.put(`/api/reports/approve/${this.id}`, { approved, isCheckedSendMail: this.isCheckedSendMail })
      this.loading = false

      markAsSavedSession('report')
      setStepSession('report', 3, `${this.id}`)
      this.saved = true
      this.$emit('hasChange', false)
    },
    onReturnClicked() {
      this.$emit('change', 2)
    },
    onNextClicked() {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>
